// GCS上のエクスポートファイル名からダウンロード時の表示ファイル名を導出する。
// GCS上のファイル名は2形式ある:
//   旧: {timestamp}.SDS一覧.xlsx / {timestamp}.SDS一覧_{format}.csv → 先頭のtimestampを除いた部分を使う
//   新(SE-593以降): {job_id}.xlsx / {job_id}.csv → 表示名を持たないため既定名にフォールバック
//     (新形式はメールリンクの displayFilename パラメータで表示名が渡ってくる想定で、
//      この関数はパラメータが無い場合のフォールバック)
export const deriveDownloadFilename = (
  filename: string | null,
  defaultBaseName = 'SDS一覧'
): string => {
  const parts = filename?.split('.') ?? [];
  const extension = parts.length >= 2 ? parts[parts.length - 1] : 'xlsx';
  const baseName =
    parts.length >= 3 ? parts.slice(1, -1).join('.') : defaultBaseName;
  return `${baseName}.${extension}`;
};
